var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.tableData,"items-per-page":50,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var index = ref.index;
return [_c('v-btn',{attrs:{"color":"error","small":""},on:{"click":function($event){return _vm.handleRemoveRow(index)}}},[_vm._v("Löschen")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }